import { RadioGroup } from '@headlessui/react'
import classNames from '@components/utils/classNames'
import { IDeviceInfo, useUI } from '@components/ui/context'
import Link from 'next/link'

import { API_STATUS } from '@components/utils/constants'
import {
  matchStrings,
  priceFormat,
  stringToBoolean,
  tryParseJson,
} from '@framework/utils/parse-util'
import { getCurrentPage, getDeviceInfo } from '@framework/utils/app-util'
import { Skeleton } from '@components/ui'
import { IProduct } from '@components/utils/model/product.model'
import { IProductCorrectStockPerAttribute } from './AttributesHandlerProductView'
import { useSizeLineHook, separatorSign } from './hook/sizeInLine.hook'
import dynamic from 'next/dynamic'
import { IMAGE_ASSET_BASE_URL } from '@framework/utils/constants'
import { useEffect, useState } from 'react'
import CmsPage from './CmsPageModal'
import Router, { useRouter } from 'next/router'

const SizeInLineTransition = dynamic(
  () => import('./helper/SizeInLineTransition.component')
)
declare const window: any

interface IProps {
  product: IProduct
  forInputSelection: boolean
  selectedValue: any
  setQuickview: any
  items: any
  label: string
  fieldCode: string
  currentAttribute: string
  productId: string
  selectedSizeProduct: any
  selectedSizeProductDiscount: any
  currentVariantData: any
  callToAction: any
  allowCart: boolean
  hideMRP: boolean
  currentPage: string
  onChange: (fieldCode: string, value: string, obj?: any) => void
  getStockPerAttribute: (
    key: string,
    variant: string
  ) => IProductCorrectStockPerAttribute
  setGetColorAPIStatus: (payload: API_STATUS) => void
}

export default function SizeInline({
  items = [],
  onChange = () => {},
  label = '',
  fieldCode = '',
  getStockPerAttribute,
  productId,
  product,
  selectedSizeProduct,
  selectedSizeProductDiscount,
  callToAction = null,
  allowCart = true,
  currentVariantData,
  forInputSelection = false,
  selectedValue = null,
  setQuickview = null,
  currentPage,
  hideMRP = false,
  setGetColorAPIStatus,
}: IProps) {
  const { openNotifyUser, setNotifyProduct } = useUI()
  let isMobile = false
  const currentAttribute = product?.customAttributes?.find((x: any) =>
    matchStrings(x?.key, 'clothing.size', true)
  )?.valueText
  const deviceInfo = getDeviceInfo() as IDeviceInfo
  const _currentPage = getCurrentPage()
  const {
    isSizeChart,
    enabled,
    isSizeChange,
    SizeChart,
    selected,
    isImageLoaded,
    isSizeChartEnable,
    discount,
    selectedSizeInLineProductDiscount,
    selectedSizeInLineProduct,
    isInWishList,
    attrGroup,
    handleWishList,
    sanitizeSize,
    isVisible,
    generateItemOption,
    handleChangeFromSizeChart,
    handleChange,
    sizeChart,
    setIsImageLoaded,
    setEnable,
    setSizeChart,
    setDisabled,
  } = useSizeLineHook({
    product,
    items,
    fieldCode,
    currentAttribute,
    currentVariantData,
    selectedSizeProduct,
    currentPage,
    isMobile,
    productId,
    window,
    setQuickview,
    onChange,
    getStockPerAttribute,
  })

  const { asPath } = useRouter()
  const [isCmsOpen, setCmsOpen] = useState(false)
  const [cmsData, setCms] = useState<any>({})

  if (deviceInfo) {
    const parseDeviceInfo = tryParseJson(deviceInfo) as IDeviceInfo
    isMobile = !!parseDeviceInfo?.isMobile
  }

  const arrItems = new Array(...items)

  let bannerDetails: any = null

  const getBannerDetails = (product: any) => {
    const bannerDetails = {
      show: null,
      url: null,
    }
    // availableStocks = product?.variantProducts?.reduce(
    //   (sum: number, current: any) => {
    //     return sum + current.currentStock
    //   },
    //   0
    // )
    // if (availableStocks <= 0 || true) {
    for (const attribute in product?.customAttributes) {
      if (product?.customAttributes?.[attribute]?.['key'] == 'product.oos') {
        bannerDetails.show =
          product?.customAttributes?.[attribute]?.value &&
          stringToBoolean(product?.customAttributes?.[attribute]?.value)
      } else if (
        product?.customAttributes?.[attribute]?.['key'] == 'product.oosbanner'
      ) {
        bannerDetails.url = product?.customAttributes?.[attribute]?.value
      }
    }
    // }
    const data = {
      show: bannerDetails?.show || false,
      url: tryParseJson(bannerDetails?.url) as any || {},
    }
    return data
  }
  bannerDetails = getBannerDetails(product)
  
  const handleLink = (bannerDetails: any) => {
    let href;
    if(bannerDetails?.type === 'page' || bannerDetails?.type === 'typeform'){
      href = bannerDetails?.link
    }
    if(bannerDetails?.type === 'cms'){
      href = bannerDetails?.link
    }
    return { href }
  }
  const { href } = handleLink(bannerDetails?.url)

  const handleBannerClick = (product: any, bannerDetails: any) => {
    if(bannerDetails?.type === 'notify'){
      openNotifyUser(product?.recordId)
      setNotifyProduct(product)
    }
    if (bannerDetails?.type === 'cms') {
      if (!!bannerDetails?.link) {
        setCms(bannerDetails)
        Router?.push(
          { pathname: `${asPath}#cmsModal` },
          `${asPath}#cmsModal`,
          { shallow: true, scroll: false }
        )
      }
    }
  }

  const handleCmsModalOpen = (e: any) => {
    if (!e) {
      const newUrl = asPath?.replaceAll('#cmsModal', '')
      Router.replace(newUrl)
      setCmsOpen(false)
    }
  }

  useEffect(() => {
    const isCmsShouldOpen = asPath?.includes('#cmsModal')
    if (isCmsOpen || isCmsShouldOpen) {
      if (isCmsShouldOpen) {
        setCmsOpen(true)
      } else {
        handleCmsModalOpen(false)
      }
    }
  },[asPath])
  return (
    <>
      <div
        className={`${
          currentPage !== 'Return & Exchange'
            ? `${currentPage === 'PDP' ? 'px-2 sm:px-2' : 'px-6 sm:px-6'} `
            : ''
        }`}
      >
        <div
          className="grid w-full grid-cols-3 px-0 border-gray-200 border-solid hide-swach-padding sm:border-t"
          id="productSize"
        >
          <div className="col-span-2 item-left">
            <h3 className="pt-3 text-xs font-semibold text-left text-gray-500 uppercase dark:text-black mob-text-xs sm:text-sm">
              {SizeChart?.attribute?.length > 0 ? (
                <span className="font-medium opacity_056 text-primary">
                  {label}
                </span>
              ) : (
                <span className="">
                  {isSizeChartEnable === API_STATUS.LOADING && (
                    <Skeleton
                      height="1rem"
                      width="20%"
                      style={{
                        width: '20%',
                        // margin: 'auto',
                        marginTop: '5px',
                        borderRadius: '5px',
                        background: 'rgba(0, 0, 0, 0.11)',
                      }}
                    />
                  )}
                </span>
              )}
              {SizeChart?.attribute?.length > 0 ? (
                <div className="text-xs font-bold text-black mob-text-xs sm:text-sm">
                  {SizeChart?.attribute?.map((att: any, index: number) => {
                    return (
                      <div key={`attr-${index}`}>
                        {att?.Values?.map((data: any, did: number) => {
                          return (
                            <div key={did}>
                              {matchStrings(
                                data?.FieldText ?? '',
                                currentVariantData
                                  ? currentVariantData
                                  : currentAttribute ?? '',
                                true
                              ) && (
                                <span key={did}>
                                  <div className="py-1 text-sm font-medium mob-text-xs">
                                    <span className="mr-1 font-medium opacity_056 text-primary">
                                      {data?.FieldValue}
                                    </span>
                                  </div>
                                </span>
                              )}
                            </div>
                          )
                        })}
                      </div>
                    )
                  })}
                </div>
              ) : (
                <span className="">
                  {isSizeChartEnable === API_STATUS.LOADING && (
                    <Skeleton
                      height="1rem"
                      width="70%"
                      style={{
                        width: '70%',
                        // margin: 'auto',
                        marginTop: '5px',
                        borderRadius: '5px',
                        background: 'rgba(0, 0, 0, 0.11)',
                      }}
                    />
                  )}
                </span>
              )}
            </h3>
          </div>
          <div className="col-span-1 mt-3 text-right item-right relative">
            {SizeChart?.Sizes?.length > 0 ? (
              <h3
                className="text-sm font-semibold text-orange-600 cursor-pointer sm:text-md hover:text-orange-700"
                onClick={() => sizeChart()}
              >
                Size Chart
              </h3>
            ) : (
              <span className="">
                {isSizeChartEnable === API_STATUS.LOADING && (
                  <Skeleton
                    height="1rem"
                    width="60%"
                    style={{
                      width: '60%',
                      // margin: 'auto',
                      marginTop: '5px',
                      borderRadius: '5px',
                      background: 'rgba(0, 0, 0, 0.11)',
                      position: 'absolute',
                      right: '0',
                    }}
                  />
                )}
              </span>
            )}
          </div>
        </div>
        <RadioGroup
          value={'ring-gray-700'}
          className={`${
            currentPage === 'PLP Quick View'
              ? 'px-1 sm:px-1 md:px-1'
              : 'px-1 sm:px-1 md:px-1'
          } mt-3 mb-4 overflow-x-auto hide-scrollbar-visibility`}
        >
          <RadioGroup.Label className="sr-only">{label}</RadioGroup.Label>
          <div className="flex items-center pt-3 pb-5 space-x-2">
            {arrItems
              ?.sort((a: any, b: any) => a.displayOrder - b.displayOrder)
              ?.map((item: any, idx: any) => {
                const stockAmount = getStockPerAttribute(
                  fieldCode,
                  item.fieldValue
                ).stock
                let soldoutCls = 'bg-white text-primary'
                if (stockAmount == 0) {
                  soldoutCls = 'bg-gray-100 pointer-event-none text-gray-300'
                }
                let selectedSoldOutCls = 'bg-red-8/100 border-red-800'
                return (
                  <RadioGroup.Option
                    key={`radio-${idx}`}
                    value={item.fieldValue}
                    className="relative flex flex-col justify-center text-center"
                    onClick={(event: any) => {
                      handleChange(item)
                    }}
                  >
                    <>
                      <div
                        className={classNames(
                          `${
                            (!forInputSelection
                              ? matchStrings(
                                  currentVariantData
                                    ? currentVariantData
                                        ?.toUpperCase()
                                        ?.replaceAll('-', ' ')
                                    : currentAttribute
                                        ?.toUpperCase()
                                        ?.replaceAll('-', ' '),
                                  sanitizeSize(
                                    item?.fieldValue?.replaceAll('-', ' ')
                                  ),
                                  true
                                )
                              : matchStrings(
                                  selectedValue ? selectedValue[fieldCode] : '',
                                  sanitizeSize(item?.fieldValue),
                                  true
                                )) && stockAmount > 0
                              ? 'border-gray-800'
                              : soldoutCls
                          }

                        ${
                          stockAmount === 0 &&
                          (matchStrings(
                            currentVariantData
                              ? currentVariantData
                              : currentAttribute,
                            sanitizeSize(item?.fieldValue),
                            true
                          )
                            ? selectedSoldOutCls
                            : 'text-brown-xlight')
                        }`,

                          '-m-0.5 relative p-2 border-2 w-16 h-16 dark:text-black border-opacity-1 rounded-sm text-md content-center text-center flex items-center justify-center cursor-pointer focus:outline-none hover:bg-zinc-50'
                        )}
                      >
                        <Link legacyBehavior href="javascript:void(0);">
                          <>
                            <a
                              aria-hidden="true"
                              className={classNames(
                                item.fieldvalue,
                                'select-product-size'
                              )}
                              data-value={
                                item.fieldValue
                                  ? generateItemOption(
                                      item.fieldValue,
                                      stockAmount
                                    )
                                      ?.split(separatorSign)[0]
                                      ?.trim()
                                  : null
                              }
                            >
                              {item.fieldValue
                                ? generateItemOption(
                                    item.fieldValue,
                                    stockAmount
                                  )?.split(separatorSign)[0]
                                : null}
                            </a>

                            <div
                              className={classNames(
                                selected.currentAttribute ==
                                  generateItemOption(
                                    item?.fieldValue,
                                    stockAmount
                                  )?.toLowerCase()
                                  ? 'inline-block top-14'
                                  : '',
                                'absolute block w-14 text-xs font-semibold text-dark-red mt-20 mob-stck-font'
                              )}
                            >
                              {item.fieldValue
                                ? generateItemOption(
                                    item.fieldValue,
                                    stockAmount
                                  )?.split(separatorSign)[1]
                                : null}
                            </div>
                            {/* )} */}
                          </>
                        </Link>
                      </div>

                      <div
                        className={classNames(
                          selected.currentAttribute ==
                            generateItemOption(
                              item?.fieldValue,
                              stockAmount
                            )?.toLowerCase()
                            ? 'inline-block top-14'
                            : 'hidden',
                          'absolute block w-14 mt-1 text-xs font-semibold text-red-500'
                        )}
                      >
                        {item.fieldValue
                          ? generateItemOption(
                              item.fieldValue,
                              stockAmount
                            )?.split(separatorSign)[1]
                          : null}
                      </div>
                    </>
                  </RadioGroup.Option>
                )
              })}
          </div>
        </RadioGroup>
      </div>

      {bannerDetails?.show && bannerDetails?.url && (
        <div
          className="flex justify-between flex-col mt-4 sm:px-0 mb-4"
          onClick={() => handleBannerClick(product, bannerDetails?.url)}
        >
          {(bannerDetails?.url?.type === 'page' || bannerDetails?.url?.type === 'typeform') ? 
          <Link legacyBehavior href={href} passHref>
            <img
              placeholder="blur"
              src={`${IMAGE_ASSET_BASE_URL}/${bannerDetails?.url?.img || ''}`}
              alt={'OOS Banner'}
              // width={400}
              height={119}
              className="object-cover object-center w-full h-full radius-xs sm:h-full"
            />
          </Link> : (
            <>
              <img
                placeholder="blur"
                src={`${IMAGE_ASSET_BASE_URL}/${bannerDetails?.url?.img || ''}`}
                alt={'OOS Banner'}
                // width={400}
                height={119}
                className="object-cover object-center w-full h-full radius-xs sm:h-full cursor-pointer"
              />
            </>
          )}
        </div>
      )}
      <div
        className={`${
          currentPage !== 'Return & Exchange'
            ? `${
                _currentPage === 'PDP'
                  ? 'px-4 sm:px-4 md:px-0'
                  : 'px-0 sm:px-0 md:px-0'
              } `
            : ''
        }`}
      >
        {/* DAM-198 */}
        {/* To Show price of product under size selection */}
        {!hideMRP ? (
          <div className="flex flex-col w-full" id="productColors">
            <div
              className={`flex justify-between order-2 ${
                currentPage === 'PLP Quick View' ? 'px-0' : 'px-0'
              } mt-1 sm:order-1 sm:px-0`}
            >
              <div className="item-left">
                <p className="h-5 text-sm font-semibold text-primary sm:text-md">
                  {`${
                    (selectedSizeProduct || product)?.listPrice?.raw?.withTax >
                    (selectedSizeProduct || product)?.price?.raw?.withTax
                      ? ''
                      : 'MRP'
                  } ${priceFormat((selectedSizeProduct || product)?.price?.raw?.withTax)}`}
                  {(selectedSizeProduct || product)?.listPrice?.raw?.withTax >
                  (selectedSizeProduct || product)?.price?.raw?.withTax ? (
                    <>
                      <span className="px-2 text-sm font-normal text-brown-light sm:text-md">
                        MRP{' '}
                        <span className="line-through">
                          {priceFormat(
                            selectedSizeProduct?.listPrice?.raw?.withTax
                          )}
                        </span>
                      </span>
                      {discount > 0 && (
                        <span className="text-sm font-normal text-green sm:text-md">
                          {discount}% off
                        </span>
                      )}
                    </>
                  ) : null}
                </p>
                <p className="pt-1 text-sm font-normal text-brown-light sm:text-md">
                  Inclusive of all taxes
                </p>
              </div>
            </div>
          </div>
        ) : (
          ''
        )}
        {/* QUICK VIEW PANEL FROM BOTTOM */}
        <SizeInLineTransition
          isSizeChart={isSizeChart}
          product={product}
          SizeChart={SizeChart}
          isImageLoaded={isImageLoaded}
          deviceInfo={deviceInfo}
          isSizeChange={isSizeChange}
          enabled={enabled}
          currentVariantData={currentVariantData}
          currentAttribute={currentAttribute}
          selectedSizeProduct={selectedSizeProduct}
          allowCart={allowCart}
          attrGroup={attrGroup}
          selectedSizeInLineProduct={selectedSizeInLineProduct}
          selectedSizeInLineProductDiscount={selectedSizeInLineProductDiscount}
          selectedSizeProductDiscount={selectedSizeProductDiscount}
          callToAction={callToAction}
          isInWishList={isInWishList}
          handleWishList={handleWishList}
          setDisabled={setDisabled}
          setEnable={setEnable}
          setIsImageLoaded={(payload: boolean) => {
            setIsImageLoaded(payload)
          }}
          setSizeChart={(payload: boolean) => {
            setSizeChart(payload)
          }}
          handleChange={handleChange}
          handleChangeFromSizeChart={handleChangeFromSizeChart}
          sanitizeSize={sanitizeSize}
          isVisible={isVisible}
        />
      </div>

      {isCmsOpen && <CmsPage open={isCmsOpen} setOpen={setCmsOpen} data={cmsData} deviceInfo={deviceInfo} handleCmsModalOpen={handleCmsModalOpen} />}
    </>
  )
}
